import { Moon, Sun } from 'lucide-react';
import { useTheme } from './ThemeContext';

interface ThemeToggleProps {
  /** Render the current theme label next to the icon (used in the sidebar). */
  showLabel?: boolean;
  className?: string;
}

/**
 * Dark/Light theme switch. Shows a sun in dark mode (click → go light) and a
 * moon in light mode (click → go dark). Preference is persisted via the
 * ThemeProvider (localStorage + prefers-color-scheme default).
 */
export function ThemeToggle({ showLabel = false, className = '' }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  const nextLabel = isDark ? 'Comută la modul luminos' : 'Comută la modul întunecat';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={nextLabel}
      title={nextLabel}
      // `justify-center` is load-bearing on touch devices: the coarse-pointer
      // rule in index.css inflates every button to a 44x44 hit area, and the
      // 30px icon would otherwise sit at flex-start — visibly left of centre
      // inside its own hover/focus box.
      className={`inline-flex items-center justify-center gap-2 rounded-md p-1.5 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${className}`}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
      {showLabel && (
        <span className="text-sm font-medium">{isDark ? 'Mod luminos' : 'Mod întunecat'}</span>
      )}
    </button>
  );
}
